module.exports = __webpack_public_path__ + "static/media/Snare1.67df267a.wav";